import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import Icons from '../../utils/icons';
import { faCheckCircle, faX } from '@fortawesome/free-solid-svg-icons';
import Confirm from '../Modal/Alert/confirm';

const ValidationModal = ({ isOpen, onClose, demande, onValidate, onContact, onDelete }) => {

  const [showAlert, setShowAlert] = useState(false)
  
  return isOpen ? (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-auto bg-black bg-opacity-50">
      <div className="items-center self-center justify-center w-full max-w-2xl p-6 m-10 overflow-auto bg-white rounded-lg shadow-lg dark:bg-gray-800">
        
        {/* En-tête avec boutons fermer et contacter */}
        <div className="flex items-center justify-between mb-5">
          {/* Bouton de fermeture */}
          <div
            onClick={onClose}
            className="flex items-center justify-center w-10 h-10 text-gray-700 bg-gray-200 rounded-full cursor-pointer hover:bg-gray-400 dark:bg-gray-600 dark:text-gray-200 dark:hover:bg-gray-500"
          >
            <FontAwesomeIcon icon={faX} />
          </div>

          {/* Bouton Contacter */}
          <div
            onClick={onContact}
            className="px-4 py-1 text-gray-700 bg-gray-200 cursor-pointer rounded-xl hover:bg-gray-300 dark:bg-gray-600 dark:text-gray-200 dark:hover:bg-gray-500"
          >
            Contacter
          </div>
        </div>

        

        {/* Détails de la demande */}
        <div className='flex flex-row flex-wrap items-center justify-between'>
          <div className="mb-4 text-gray-700 dark:text-gray-300">
            <p><strong>Nom et prénom :</strong> {demande.owner.client.firstname} {demande.owner.client.lastname}</p>
            <p><strong>Email :</strong> {demande.owner.client.email}</p>
            <p><strong>Adresse :</strong> {demande.owner.address}</p>
            <p><strong>MTN Money :</strong> {demande.owner.mtnMoney}</p>
            <p><strong>Airtel Money :</strong> {demande.owner.airtelMoney}</p>
            <p><strong>Profession :</strong> {demande.owner.profession}</p>
            <p><strong>Date de la demande :</strong> {new Date(demande.owner.createdAt).toLocaleString()}</p>
          </div>

          {/* Image de la carte d'identité */}
          <div className="mb-4 ml-7">
            <img 
              src={`${process.env.REACT_APP_API_PICTURE_URL}${demande.owner.cniPicture}`} 
              alt="Carte d'identité" 
              width={200}
              className="items-center my-5 transition-shadow duration-300 rounded-md shadow-md hover:shadow-lg"
            />
          </div>
        </div>

        {/* Boutons d'action */}
        {demande.owner.isVerified === false && (
          <div className="flex items-center justify-between mt-6 text-center">
            {/* Supprimer */}
            <div
              onClick={onDelete}
              className="px-4 py-2 text-white transition-colors duration-200 bg-red-600 rounded cursor-pointer hover:bg-red-700"
            >
              Supprimer
            </div>
            {/* Valider */}
            <div
              onClick={onValidate}
              className="px-4 py-2 text-white transition-colors duration-200 bg-indigo-600 rounded cursor-pointer hover:bg-indigo-700"
            >
              Valider
            </div>
          </div>
        )}

        {/* Si déjà validée */}
        {demande.owner.isVerified === true && (
          <div
            className="w-full px-4 py-2 mt-6 text-center bg-gray-100 border-2 border-gray-500 rounded-md cursor-pointer dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200"
          >
            <p>Validée</p>
          </div>
        )}
      </div>

      <Confirm
        open={showAlert}
        onClose={()=>setShowAlert(false)}
        onAccept={onValidate}
        onDecline={()=>setShowAlert(false)}
        message={'Voulez vous vraiment valider cette demande ?'}
      />

    </div>

  ) : null;
};

export default ValidationModal;
